import { IBank } from 'app/shared/model/bank.model';

export interface IBankAgreementDateLog {
  id?: number;
  agreementDate?: string | null;
  oldValue?: string | null;
  commodity?: string | null;
  bank?: IBank | null;
  bankId?: number | null;
  createdDate?: string | null;
}

export const defaultValue: Readonly<IBankAgreementDateLog> = {};
